import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import { envSegmentToSegmentType } from '@innogy/utils-deprecated';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MarkAsSubmittedAction } from 'ngrx-forms';
import { filter, map, mergeMap } from 'rxjs/operators';

import { tariffBreakdownAddressDataSubmitAction } from './tariff-breakdown.actions';
import { tariffBreakdownComponentKey } from './tariff-breakdown.reducer';
import { getMarketingModelContract } from './get-marketing-model-contract';

@Injectable()
export class TariffBreakdownEffects {
  constructor(
    private readonly actions$: Actions,
    @Inject(ENVIRONMENT_CONFIG)
    private readonly environmentConfig: EnvironmentConfig
  ) {}

  public readonly submitTariffBreakdownForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tariffBreakdownAddressDataSubmitAction),
      map(() => new MarkAsSubmittedAction(tariffBreakdownComponentKey))
    )
  );

  public readonly submitTariffBreakdownFormSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tariffBreakdownAddressDataSubmitAction),
      filter(
        (action): action is typeof action & { campaignId: string } =>
          action.campaignId !== undefined && action.formIsValid
      ),
      mergeMap(({ addressKey, campaignId, rate, returnSupply }) => {
        return [
          getMarketingModelContract({
            payload: {
              addressKey,
              segment: envSegmentToSegmentType(this.environmentConfig.segment),
              rate,
              returnSupply,
              campaignId,
            },
          }),
        ];
      })
    )
  );
}
